import { render } from "./InfoAccionista_Juridico.vue?vue&type=template&id=6b91d1de&ts=true"
import script from "./InfoAccionista_Juridico.vue?vue&type=script&lang=ts"
export * from "./InfoAccionista_Juridico.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__